var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "892DEF26-2840-4B6B-868E-71C26B0F7201") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Assign-Auditor",
    transform: "translate(-1577.000000, -933.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1577.000000, 933.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    transform: "translate(25.000000, 25.000000) scale(1, -1) translate(-25.000000, -25.000000) ",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6375,28.7375 C24.9375,28.7375 25.2375,28.6375 25.4375,28.4375 L30.9375,22.9375 C31.1375,22.7375 31.2375,22.4375 31.2375,22.1375 C31.2375,21.8375 31.1375,21.5375 30.9375,21.3375 C30.7375,21.1375 30.4375,21.0375 30.1375,21.0375 C29.8375,21.0375 29.5375,21.1375 29.3375,21.3375 L24.6375,26.0375 L19.9375,21.3375 L19.9375,21.3375 C19.6375,21.0375 19.2375,20.9375 18.8375,21.0375 C18.4375,21.1375 18.1375,21.4375 18.0375,21.8375 C17.9375,22.2375 18.0375,22.6375 18.3375,22.9375 L23.8375,28.4375 C24.0375,28.6375 24.3375,28.7375 24.6375,28.7375 L24.6375,28.7375 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.299383254,
    transform: "translate(24.618750, 24.868750) rotate(-90.000000) translate(-24.618750, -24.868750) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.f6da2786957540208f838de7cfa571cc.svg";
export { ForwardRef as ReactComponent };